export default {
  Notification:{
    zIndex:2000,
    position:'fixed',
  },
  tl:{
    top:20,
    left:20,
  },
  tm:{
    top:20,
    left:'40%',
  },
  tr:{
    top:20,
    right:20,
  },
  bl:{
    bottom:20,
    left:20,
  },
  bm:{
    bottom:20,
    left:'40%',
  },
  br:{
    bottom:20,
    right: 20,
  },
}



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/views/notification.jsx